import { motion } from "framer-motion";
import { MASSAGES } from "@/data/site";
import SectionLabel from "./SectionLabel";

export default function Pricing({ onBook }) {
  return (
    <section
      id="tarifs"
      className="relative py-24 md:py-32 bg-[#EFEBE3]"
      data-testid="pricing-section"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <SectionLabel
          eyebrow="Tarifs"
          title={<>Une grille tarifaire<br /><span className="italic text-[#8B5A2B]">claire et transparente</span></>}
          subtitle="Tous nos soins sont réalisés avec des huiles biologiques sélectionnées. Les tarifs s'entendent toutes taxes comprises."
          center
        />

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="bg-[#F9F6F0] rounded-2xl p-8 md:p-12 shadow-[0_10px_60px_rgba(28,25,23,0.05)] border border-[#E6DFD3]"
        >
          <ul className="divide-y divide-[#E6DFD3]">
            {MASSAGES.flatMap((m) =>
              m.options.map((o, i) => (
                <motion.li
                  key={`${m.id}-${o.duration}`}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.04 }}
                  className="flex items-baseline gap-4 py-5 md:py-6 group"
                  data-testid={`price-row-${m.id}-${o.duration.replace(/\s/g, "")}`}
                >
                  <span className="font-display text-stone-900 text-xl md:text-2xl font-normal flex-shrink-0">
                    {m.name}
                  </span>
                  <span className="flex-1 border-b border-dotted border-stone-300 mb-1.5 group-hover:border-[#C5A059] transition-colors duration-500" />
                  <span className="text-stone-500 text-sm font-body tracking-wide uppercase flex-shrink-0">
                    {o.duration}
                  </span>
                  <span className="font-display text-[#8B5A2B] text-2xl md:text-3xl font-medium flex-shrink-0 min-w-[80px] text-right">
                    {o.price}
                  </span>
                </motion.li>
              ))
            )}
          </ul>
          <div className="mt-10 text-center">
            <button
              onClick={onBook}
              data-testid="pricing-book-btn"
              className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-stone-900 text-[#F9F6F0] font-body font-medium hover:bg-stone-800 transition-all duration-500 hover:-translate-y-0.5"
            >
              Réserver mon soin
              <span>→</span>
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
